module.exports = __webpack_public_path__ + "static/media/W19-1155_Beyond_Meat_3.99_Mobile_767x845.18706830.jpg";